var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'room-default',
    _setup.isUniFrameWork && 'room-default-uni',
    _setup.props.message.flow === 'in' ? 'room-default-in' : 'room-default-out',
  ]},[_vm._v(" "+_vm._s(_setup.TUITranslateService.t("message.custom.自定义消息"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }